import React, { useEffect, useState } from 'react';
import { databaseService } from '../../services/database.service';
import { i18nService } from '../../services/i18n.service';
import { useLanguageContext } from '../../contexts/LanguageContext';
import LoadingSpinner from '../../components/common/LoadingSpinner';

const PrivacyPolicyPage = () => {
  const { currentLanguage } = useLanguageContext();
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const data = await databaseService.getPageContent('privacyPolicy');
        setPageData(data);
      } catch (error) {
        console.error('Error fetching privacy policy:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  // Get content in current language
  const content = pageData ? i18nService.getTranslatedField(pageData, 'content', currentLanguage, 'nl') : '';

  return (
    <div className="py-12">
      <div className="container mx-auto px-4 max-w-4xl">
        <h1 className="text-4xl font-display font-bold mb-8">Privacy Policy</h1>
        {content ? (
          <div
            className="prose prose-lg max-w-none"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        ) : (
          <div className="text-gray-600">
            <p className="mb-4">Privacy Policy content will be available soon.</p>
            <p>Please contact us if you have any questions about how we handle your data.</p>
          </div>
        )}
        {pageData?.lastUpdated && (
          <p className="text-sm text-gray-500 mt-8">
            Last updated: {new Date(pageData.lastUpdated).toLocaleDateString()}
          </p>
        )}
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
